module.exports = __webpack_public_path__ + "img/logo2.a8e8d596.png";